"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signer = void 0;
const api_actions_enum_1 = require("./constants/api-actions.enum");
class Signer {
    constructor(messages) {
        this.messages = messages;
    }
    signMessage(podName, message) {
        return this.messages.sendMessage(api_actions_enum_1.ApiActions.SIGNER_SIGN_MESSAGE, { podName, message });
    }
}
exports.Signer = Signer;
